import React from 'react';
import { Form, reduxForm, Field } from 'redux-form';

import { ReduxFileInput } from '../../components/ReduxInput';
import { Card, Label, Button, FormGroup, CardHeader, CardBody, Row, Col, Table } from 'reactstrap';

import AreYouSureModal from '../../components/AreYouSureModal';

class ImportForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      areYouSureVisible: false
    }
    
    this.toggleAreYouSure = this.toggleAreYouSure.bind(this);
  }

  toggleAreYouSure(arg1, arg2, arg3) {
    //console.log(arg1);
    //console.log(arg2);
    //console.log(arg3);
    console.log(this.props);
    this.setState({
      areYouSureVisible: !this.state.areYouSureVisible
    });
  }


  render() {
    const { handleSubmit, disableButtons, accept } = this.props;
    const { areYouSureVisible } = this.state;
    const {toggleAreYouSure} = this;
    return (
      <Card >
        <AreYouSureModal
          onSubmit={() => {
            handleSubmit();
            toggleAreYouSure();
          }}
          additionalText={"This operation will delete all rates and replace them with the upladed rates. It is recommended that you \"Download as CSV\" the current rates should you need to revert to them.\n"}
          confirmText={"IMPORT"}
          toggle={this.toggleAreYouSure}
          isOpen={areYouSureVisible}
        />

        <CardBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Field
                accept={accept}
                name={"file"}
                type="file"
                component={ReduxFileInput} />
            </FormGroup>
            <FormGroup>
              <Button 
             //type="submit" 
              disabled={disableButtons} onClick={this.toggleAreYouSure} color="primary" block>
                <i className="fa fa-upload" /> &nbsp;Import
              </Button>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    );
  }
}

export default reduxForm({
  form: 'ImportForm', // a unique identifier for this form
})(ImportForm);




// WEBPACK FOOTER //
// ./src/components/RateManagment/ImportForm.js